import { useEffect, useState } from 'react';

/**
 * Which product demo clips actually exist.
 *
 * /demos/manifest.json is written by scripts/record-demos.mjs and committed. A
 * card only renders a <video> for a slug the manifest names, which is what keeps
 * a half-finished recording session from leaving a broken tile on the homepage:
 * no entry, no request, no 404, just the screenshot that was always there.
 *
 * One fetch per page load, shared by every card, and the file is a few hundred
 * bytes.
 */

let inflight = null;

function load() {
  if (!inflight) {
    inflight = fetch('/demos/manifest.json')
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return inflight;
}

export function useDemoClips() {
  const [clips, setClips] = useState(null);

  useEffect(() => {
    let active = true;
    load().then((data) => {
      if (active) setClips(data?.clips || {});
    });
    return () => {
      active = false;
    };
  }, []);

  return {
    clipFor: (slug) => (slug && clips ? clips[slug] || null : null),
    ready: clips !== null,
  };
}

export default useDemoClips;
